export enum AssignJobSteps {
  Details = "details",
  UserSelection = "user-selection",
  Result = "result",
}
